import { render } from "./PageNotFound.vue?vue&type=template&id=46c4501d"
import script from "./PageNotFound.vue?vue&type=script&lang=js"
export * from "./PageNotFound.vue?vue&type=script&lang=js"
script.render = render

export default script